import { AppType } from './app';
import { AdminAppType } from './routes/admin';
import { PointsConfigurationRouteType } from './routes/admin/points-configuration';
import { AdministratorsAppType } from './routes/admin/administrators';
import {
  ClientRequestOptions,
  hc,
  InferRequestType,
  InferResponseType
} from 'hono/client';
import { GetEventsAppType } from './routes/events/getEvents';

const baseUrl =
  process.env.NEXT_PUBLIC_SERVER_BASE_URL ||
  process.env.EXPO_PUBLIC_SERVER_BASE_URL ||
  'http://localhost:3001';
const adminBaseUrl = `${baseUrl}/api/v1.0/admin`;

const getClient = (options?: ClientRequestOptions) =>
  hc<AppType>(baseUrl, options);

const getAdminClient = (options?: ClientRequestOptions) =>
  hc<AdminAppType>(adminBaseUrl, options);

const getEventsClient = (options?: ClientRequestOptions) =>
  hc<GetEventsAppType>(
    process.env.NEXT_PUBLIC_SERVER_GET_EVENTS_BASE_URL ||
      `${baseUrl}/api/v1.0/events`,
    options
  );

const getPointsConfigurationAdminClient = (options?: ClientRequestOptions) =>
  hc<PointsConfigurationRouteType>(adminBaseUrl, options);

const getAdministratorsAdminClient = (options?: ClientRequestOptions) =>
  hc<AdministratorsAppType>(adminBaseUrl, options);

export {
  getClient,
  getAdminClient,
  getEventsClient,
  getPointsConfigurationAdminClient,
  getAdministratorsAdminClient
};
export type { InferRequestType, InferResponseType };
